import { useContext } from "react";
import { ReplicateActionContext } from "./ReplicateActionContext";
import replicateInvoice from "./replicateInvoice";

function useReplicate() {
  const { elementId, setShowModal, setLoading } = useContext(ReplicateActionContext);
  return (onSuccess: (newId: number) => void) => {
    setLoading(true);
    replicateInvoice(elementId, (newInvoiceId: number) => {
      setShowModal(false);
      onSuccess(newInvoiceId);
      setLoading(false);
    });
  };
}

export default useReplicate;
